import { useEffect, useState } from "react";
import Markdown, { defaultUrlTransform } from "react-markdown";
import { useTranslation } from "react-i18next";

import { Button, Buttons, Panel } from "capitalrx-components-2.0/lib/general";
import { Stack } from "capitalrx-components-2.0/lib/layout";
import { Body, Heading } from "capitalrx-components-2.0/lib/typography";

import { useNavigateSearch, useSelectedEnrollmentPlan } from "@/premium/hooks";
import { Breadcrumbs, PageLayout} from "@/premium/themedComponents";
import { PaymentCalculator } from "./";
import "./MedicarePrescriptionPaymentPlan.scss";

const TRANSLATION_PATH = "MEDICARE_PRESCRIPTION_PAYMENT_PLAN.medicarePrescriptionPaymentPlan";

export const MedicarePrescriptionPaymentPlan = () => {
  const { t: translate } = useTranslation();
  const [isShowingMoreDescription, setIsShowingMoreDescription] = useState<boolean>(false);
  const navigate = useNavigateSearch();
  const {
    hideMedicarePrescriptionPaymentPlanPage,
    medicarePrescriptionPaymentPlanPhoneSection,
    medicarePrescriptionPaymentPlanOnlineSection,
    medicarePrescriptionPaymentPlanEmailSection,
    medicarePrescriptionPaymentPlanMailSection,
    medicarePrescriptionPaymentPlanExplanationSection,
  } = useSelectedEnrollmentPlan();

  // dont allow people to hit this page if they shouldnt have access
  useEffect(() => {
    if (hideMedicarePrescriptionPaymentPlanPage) {
      navigate("/");
    }
  }, [hideMedicarePrescriptionPaymentPlanPage]);

  return (
    <PageLayout>
      <Stack spacing="medium-large">
        <Breadcrumbs />
        <Heading>{translate(`${TRANSLATION_PATH}.medicarePrescriptionPayment`)}</Heading>
        <Panel className="m3p-panel">
          <Stack spacing="medium-large">
            <Stack>
              <Body className={!isShowingMoreDescription ? "collapsed" : ""}>
                <Markdown>{medicarePrescriptionPaymentPlanExplanationSection}</Markdown>
                {(medicarePrescriptionPaymentPlanOnlineSection
                  || medicarePrescriptionPaymentPlanEmailSection
                  || medicarePrescriptionPaymentPlanPhoneSection
                  || medicarePrescriptionPaymentPlanMailSection) && <b>{translate(`${TRANSLATION_PATH}.howdoISignUp`)}</b>}
                {medicarePrescriptionPaymentPlanOnlineSection && <Markdown>{medicarePrescriptionPaymentPlanOnlineSection}</Markdown>}
                {medicarePrescriptionPaymentPlanEmailSection && <Markdown>{medicarePrescriptionPaymentPlanEmailSection}</Markdown>}
                {medicarePrescriptionPaymentPlanPhoneSection && (
                  <Markdown urlTransform={(url) => (url.startsWith("tel:") ? url : defaultUrlTransform(url))}>
                    {medicarePrescriptionPaymentPlanPhoneSection}
                  </Markdown>
                )}
                {medicarePrescriptionPaymentPlanMailSection && <Markdown>{medicarePrescriptionPaymentPlanMailSection}</Markdown>}
              </Body>
              <Button
                appearance={Buttons.Functional.Tertiary.Large}
                className="m3p-view-more"
                data-testid="toggle-show"
                onClick={() => setIsShowingMoreDescription(!isShowingMoreDescription)}
              >
                {translate(`${TRANSLATION_PATH}.view`)} {!isShowingMoreDescription ? translate(`${TRANSLATION_PATH}.more`) : translate(`${TRANSLATION_PATH}.less`)}
              </Button>
            </Stack>
            <PaymentCalculator />
          </Stack>
        </Panel>
      </Stack>
    </PageLayout>
  );
};
